export const PROJECT_MANGANESE_BRAND_COLOR_PRIMARY = 'rgb(255, 23, 113)';
export const PROJECT_MANGANESE_BRAND_COLOR_SECONDARY = 'rgb(255, 56, 224)';
